export default {"src":"/_next/static/image/public/images/flags/flag_689.5c21e6095c33902de34b8e7fe449c9f6.svg","height":16,"width":24};